import { spotlightInfoBarRemove } from './createSpotlightInfoBarViewState.locstring.json';
import loc from 'owa-localize';
import Message from 'owa-service/lib/contract/Message';
import {
    lazyGetSpotlightItem,
    lazyGetSpotlightReasonString,
    lazyOnSpotlightDismissedFromRP,
} from 'owa-mail-spotlight';
import {
    InfoBarCustomAction,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function createSpotlightInfoBarViewState(
    message: Message,
    key: string
): InfoBarMessageViewState {
    const getSpotlightItem = lazyGetSpotlightItem.tryImportForRender();
    const spotlightItem = getSpotlightItem?.({ itemId: message.ItemId.Id });

    // If item is not a Spotlight item, then we should not render the Spotlight info bar.
    if (!spotlightItem) {
        return null;
    }

    // If lazy util isn't available, then we should not render the Spotlight info bar.
    const getSpotlightReasonString = lazyGetSpotlightReasonString.tryImportForRender();
    if (!getSpotlightReasonString) {
        return null;
    }

    const dismissAction: InfoBarCustomAction = {
        text: loc(spotlightInfoBarRemove),
        action: () => {
            lazyOnSpotlightDismissedFromRP.importAndExecute(spotlightItem.rowKey);
        },
    };

    return <InfoBarMessageViewState>{
        key: key,
        source: InfoBarMessageSource.ReadingPane,
        rank: InfoBarMessageRank.Spotlight,
        messageParts: [getSpotlightReasonString(spotlightItem.reason), dismissAction],
    };
}
